module.exports = require("react-dom/client");